var mostSearchedLinksMenusKeys;
(function (mostSearchedLinksMenusKeys) {
    mostSearchedLinksMenusKeys["ONLINE_TRUCK_BOOKING"] = "online-truck-booking";
    mostSearchedLinksMenusKeys["ONLINE_LOAD_BOOKING"] = "online-load-booking";
    mostSearchedLinksMenusKeys["TRANSPORTER"] = "transporter";
    mostSearchedLinksMenusKeys["TRANSPORT_SERVICE"] = "transport-service";
    mostSearchedLinksMenusKeys["TRANSPORT_DIRECTORY"] = "transport-directory";
    mostSearchedLinksMenusKeys["LORRY"] = "lorry";
})(mostSearchedLinksMenusKeys || (mostSearchedLinksMenusKeys = {}));
const mostSearchedLinksMenus = [
    { title: "Online Truck Booking", key: mostSearchedLinksMenusKeys.ONLINE_TRUCK_BOOKING },
    { title: "Online Load Booking", key: mostSearchedLinksMenusKeys.ONLINE_LOAD_BOOKING },
    { title: "Transporters", key: mostSearchedLinksMenusKeys.TRANSPORTER },
    { title: "Major Routes", key: mostSearchedLinksMenusKeys.LORRY }
];

export { mostSearchedLinksMenus, mostSearchedLinksMenusKeys };
//# sourceMappingURL=mostSearchedLinks.js.map
